import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { FormulaireService } from './formulaire.service';

@Injectable()
export class FormContactGuard implements CanActivate {

  constructor(private formulaireService: FormulaireService, private router: Router) {}

  canActivate() {
    if (this.formulaireService.getGaranties() === undefined || this.formulaireService.getGaranties().length === 0) {
      this.router.navigate(['/formulaire/garantie']);
      return null;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/form-contact-guard.service.ts